module.exports = __webpack_public_path__ + "media/images/media-elements/play-5208a404b2942adf30fc80523618592f.svg";